import * as Yup from "yup";

// Shared rules. They mirror the API's own checks (websitebe API/V1/SECURITY),
// so whatever passes here is accepted by the server.
const NAME_RE = /^[\p{L}\p{M}' .,-]+$/u;
const PHONE_RE = /^[0-9+\-(). ]+$/;
const URL_RE = /^(https?:\/\/)?[\w-]+(\.[\w-]+)+([/?#][^\s<>]*)?$/i;

const trimmed = () => Yup.string().trim();

export const rules = {
  name: (label) =>
    trimmed()
      .required(`${label} is required`)
      .max(100, `${label} must be 100 characters or fewer`)
      .matches(NAME_RE, `${label} can only contain letters, spaces, hyphens and apostrophes`),
  email: (required = true) => {
    const base = trimmed()
      .email("Enter a valid email address, like name@example.com")
      .max(254, "Email must be 254 characters or fewer");
    return required ? base.required("Email Address is required") : base;
  },
  phone: () =>
    trimmed()
      .required("Phone Number is required")
      .matches(PHONE_RE, "Phone number can only contain digits, spaces and + - ( )")
      .test("digits", "Enter a phone number with 7 to 15 digits", (v) => {
        const n = (v || "").replace(/\D/g, "").length;
        return n >= 7 && n <= 15;
      }),
  text: (label, max = 200, required = true) => {
    const base = trimmed().max(max, `${label} must be ${max} characters or fewer`);
    return required ? base.required(`${label} is required`) : base;
  },
  url: () =>
    trimmed()
      .max(300, "Website must be 300 characters or fewer")
      .test("url", "Enter a valid web address, like www.example.com", (v) => !v || URL_RE.test(v)),
  recaptcha: () => Yup.string().required("Please confirm you're not a robot."),
};

// Fields every protected form carries.
export const securityFields = {
  recaptchaToken: rules.recaptcha(),
  faxNumber: Yup.string(),
};

// axiosPost/axiosFileUploadPost never throw; they return a status code.
// Only a 2xx response counts as success.
export const isSuccess = (result) => result && result.statusCode >= 200 && result.statusCode < 300;

export const failureMessage = (result) => {
  if (!result) return "Error submitting form. Please try again.";
  if (result.statusCode === 429) return "Too many submissions. Please wait a few minutes and try again.";
  if (result.statusCode === 413) return result.responsePayload || "Submission is too large.";
  return result.responsePayload && result.statusCode < 500
    ? result.responsePayload
    : "Error submitting form. Please try again.";
};

// Shows field errors returned by the server next to the matching inputs.
export const applyServerErrors = (result, setError, knownFields) => {
  const errors = result && result.errors;
  if (!errors) return;
  Object.entries(errors).forEach(([field, message]) => {
    if (knownFields.includes(field)) setError(field, { type: "server", message });
  });
};
